import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../../../services/auth.service';
import {BaseService} from '../../../services/base.service';
import {Subject} from 'rxjs';
import {Cart} from '../models/CartModels/cart';

@Injectable({
  providedIn: 'root'
})
export class ReviewsService extends BaseService{

  private addNewCommentEventEmitter = new Subject<boolean>();


  // observables
  public AddNewCommentEvent$ = this.addNewCommentEventEmitter.asObservable();


  constructor(private httpClient: HttpClient,
              private authService: AuthService) {
    super();
  }

  getReviewsList(obj) {
    return this.httpClient.post<any>(this.baseAPI2 + '/mage/reviews/list',obj ,  this.authService.getHttpOptions());
    // return this.httpClient.get<any>(this.baseAPI2 + '/mage/orders', this.authService.getHttpOptions());
  }

  addNewProductReview(obj){

    return this.httpClient.post<any>(this.baseAPI2 + '/mage/reviews',obj ,  this.authService.getHttpOptions());
  }

  /************Events Init****************/
  EmitNewCommentAdded(data) {
    this.addNewCommentEventEmitter.next(data);
  }


}
